module.exports = __webpack_public_path__ + "static/img/wdtb.ea5977a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wdtb.jpg
// module id = vs39
// module chunks = 1